/* ============================================================
   UNWRITTENCO. JOURNALS — theme.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ── Star field ──────────────────────────────────────────
  ['stars', 'djStars'].forEach(id => {
    const container = document.getElementById(id);
    if (!container) return;
    const fragment = document.createDocumentFragment();
    const count = id === 'djStars' ? 140 : 180;
    for (let i = 0; i < count; i++) {
      const star = document.createElement('div');
      star.className = 'star';
      const size = Math.random() * 1.8 + 0.4;
      star.style.cssText = `
        width:${size}px;height:${size}px;
        left:${Math.random()*100}%;top:${Math.random()*100}%;
        --d:${(Math.random()*5+3).toFixed(1)}s;
        --delay:${(Math.random()*6).toFixed(1)}s;
        --min-op:${(Math.random()*0.1+0.04).toFixed(2)};
        --max-op:${(Math.random()*0.45+0.2).toFixed(2)};
      `;
      fragment.appendChild(star);
    }
    container.appendChild(fragment);
  });

  // ── Nav scroll ──────────────────────────────────────────
  const nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  // ── Mobile hamburger ────────────────────────────────────
  const hamburger = document.getElementById('navHamburger');
  const mobileMenu = document.getElementById('navMobile');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      const open = hamburger.classList.toggle('open');
      mobileMenu.classList.toggle('open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  // ── Dropdown — JS controlled, hover + click, no gap issues ──
  document.querySelectorAll('.nav-item--dropdown').forEach(item => {
    const trigger = item.querySelector('.nav-link--btn');
    const dropdown = item.querySelector('.nav-dropdown');
    if (!trigger || !dropdown) return;

    let closeTimer = null;

    function openDropdown() {
      clearTimeout(closeTimer);
      // Close any other open dropdowns first
      document.querySelectorAll('.nav-item--dropdown.open').forEach(other => {
        if (other !== item) other.classList.remove('open');
      });
      item.classList.add('open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function scheduleClose() {
      closeTimer = setTimeout(() => {
        item.classList.remove('open');
        trigger.setAttribute('aria-expanded', 'false');
      }, 150); // 150ms grace period — enough to move mouse to dropdown
    }

    function cancelClose() {
      clearTimeout(closeTimer);
    }

    // Hover on the parent item (trigger + dropdown both inside it)
    item.addEventListener('mouseenter', openDropdown);
    item.addEventListener('mouseleave', scheduleClose);

    // Cancel close if mouse re-enters dropdown
    dropdown.addEventListener('mouseenter', cancelClose);
    dropdown.addEventListener('mouseleave', scheduleClose);

    // Click toggle for touch devices
    trigger.addEventListener('click', (e) => {
      if (item.classList.contains('open')) {
        item.classList.remove('open');
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        openDropdown();
      }
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nav-item--dropdown')) {
      document.querySelectorAll('.nav-item--dropdown.open').forEach(item => {
        item.classList.remove('open');
      });
    }
  });

  // Close dropdowns on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.nav-item--dropdown.open').forEach(item => {
        item.classList.remove('open');
      });
    }
  });

  // ── Scroll reveal ────────────────────────────────────────
  const revealEls = document.querySelectorAll(
    '.journal-card, .pillar, .philosophy-left, .philosophy-right, .about-body-wrap, .phil-principle, .about-value, .dj-phase, .dj-detail-card, .phil-journal-row, .review-card'
  );
  if (revealEls.length && 'IntersectionObserver' in window) {
    revealEls.forEach((el, i) => {
      el.classList.add('reveal');
      el.style.transitionDelay = `${(i % 4) * 0.08}s`;
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.07 });
    revealEls.forEach(el => observer.observe(el));
  }

  // ── Smooth scroll for anchor links ──────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', e => {
      const href = link.getAttribute('href');
      if (!href || href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const navHeight = 80;
        const top = target.getBoundingClientRect().top + window.scrollY - navHeight;
        if ('scrollBehavior' in document.documentElement.style) {
          window.scrollTo({ top, behavior: 'smooth' });
        } else {
          window.scrollTo(0, top);
        }
      }
    });
  });

  // ── Accordions ──────────────────────────────────────────
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const accordion = trigger.closest('.accordion');
      const isActive = accordion.classList.contains('active');
      // Close all
      document.querySelectorAll('.accordion').forEach(a => a.classList.remove('active'));
      // Open clicked if it was closed
      if (!isActive) accordion.classList.add('active');
      trigger.setAttribute('aria-expanded', !isActive);
    });
  });

  // ── Variant buttons ─────────────────────────────────────
  const variantBtns = document.querySelectorAll('.variant-btn');
  const variantIdInput = document.getElementById('variantId');
  const priceEl = document.getElementById('productPrice');
  const atcBtn = document.getElementById('atcBtn');

  variantBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.disabled || btn.classList.contains('sold-out')) return;
      variantBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      if (variantIdInput) variantIdInput.value = btn.dataset.variantId;
      if (priceEl && btn.dataset.price) {
        priceEl.textContent = btn.dataset.price;
      }
      if (atcBtn) {
        const priceText = btn.dataset.price || '';
        const text = atcBtn.querySelector('.btn-atc-text');
        atcBtn.disabled = false;
        atcBtn.classList.remove('btn-atc--sold-out');
        if (text) text.textContent = `Add to Cart — ${priceText}`;
      }
    });
  });

  // ── Product image thumbnails ─────────────────────────────
  const mainImg = document.getElementById('productMainImg');
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.style.opacity = '0';
        mainImg.style.transition = 'opacity 0.2s';
        setTimeout(() => {
          mainImg.src = thumb.dataset.src;
          mainImg.alt = thumb.dataset.alt;
          mainImg.style.opacity = '1';
        }, 200);
      }
    });
  });

  // ── Cart drawer ──────────────────────────────────────────
  const cartDrawer  = document.getElementById('cartDrawer');
  const cartOverlay = document.getElementById('cartOverlay');
  const cartToggle  = document.getElementById('cartToggle');
  const cartClose   = document.getElementById('cartClose');
  const cartCount   = document.getElementById('cartCount');
  const cartItemsEl = document.getElementById('cartItems');
  const cartFooter  = document.getElementById('cartFooter');
  const cartTotal   = document.getElementById('cartTotal');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose)  cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Escape key closes cart
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeCart();
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => renderCart(cart))
      .catch(err => console.error('Cart fetch error:', err));
  }

  function renderCart(cart) {
    if (!cartItemsEl) return;
    if (cart.item_count === 0) {
      cartItemsEl.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      if (cartFooter) cartFooter.style.display = 'none';
    } else {
      cartItemsEl.innerHTML = cart.items.map(item => `
        <div class="cart-item" data-key="${item.key}">
          <div class="cart-item-details">
            <span class="cart-item-name">${item.product_title}</span>
            ${item.variant_title && item.variant_title !== 'Default Title'
              ? `<span class="cart-item-variant">${item.variant_title}</span>` : ''}
            <div class="cart-item-qty">
              <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
              <span>${item.quantity}</span>
              <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
            </div>
          </div>
          <div class="cart-item-right">
            <span class="cart-item-price">${formatMoney(item.final_line_price)}</span>
            <button class="cart-item-remove" data-key="${item.key}">×</button>
          </div>
        </div>
      `).join('');
      if (cartFooter) cartFooter.style.display = 'flex';
      if (cartTotal)  cartTotal.textContent = formatMoney(cart.total_price);

      cartItemsEl.querySelectorAll('.qty-btn').forEach(btn => {
        btn.addEventListener('click', () => updateCartItem(btn.dataset.key, parseInt(btn.dataset.qty)));
      });
      cartItemsEl.querySelectorAll('.cart-item-remove').forEach(btn => {
        btn.addEventListener('click', () => updateCartItem(btn.dataset.key, 0));
      });
    }
    if (cartCount) cartCount.textContent = cart.item_count;
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(r => r.json())
      .then(cart => renderCart(cart))
      .catch(err => console.error('Cart update error:', err));
  }

  // ── AJAX add to cart (collection / homepage cards) ───────
  document.querySelectorAll('.add-to-cart-form').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const data = new FormData(form);
      const btn  = form.querySelector('.btn-add-to-cart');
      const orig = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(data.get('id')), quantity: 1 })
      })
        .then(r => r.json().then(body => ({ ok: r.ok, body })))
        .then(({ ok, body }) => {
          if (!ok || body.status) {
            const msg = (body && (body.description || body.message)) || 'Could not add to cart.';
            console.error('Add to cart error:', msg);
            if (btn) { btn.textContent = 'Try again'; btn.disabled = false; }
            setTimeout(() => { if (btn) btn.textContent = orig; }, 1800);
            return;
          }
          if (btn) { btn.textContent = '✓ Added'; }
          setTimeout(() => {
            if (btn) { btn.textContent = orig; btn.disabled = false; }
            openCart();
          }, 700);
        })
        .catch(err => {
          console.error('Add to cart error:', err);
          if (btn) { btn.textContent = orig; btn.disabled = false; }
        });
    });
  });

  // ── Product page form (ATC button) ───────────────────────
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', e => {
      e.preventDefault();
      const data  = new FormData(productForm);
      const btn   = document.getElementById('atcBtn');
      const textEl = btn ? btn.querySelector('.btn-atc-text') : null;
      if (btn) { btn.classList.add('loading'); btn.disabled = true; }
      if (textEl) textEl.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(data.get('id')), quantity: 1 })
      })
        .then(r => r.json().then(body => ({ ok: r.ok, body })))
        .then(({ ok, body }) => {
          if (!ok || body.status) {
            const msg = (body && (body.description || body.message)) || 'Could not add to cart.';
            console.error('Product form error:', msg);
            if (btn) { btn.classList.remove('loading'); btn.disabled = false; }
            if (textEl) textEl.textContent = 'Try again';
            setTimeout(() => {
              if (textEl) {
                const activeVariant = document.querySelector('.variant-btn.active');
                const price = activeVariant ? activeVariant.dataset.price : '';
                textEl.textContent = `Add to Cart${price ? ' — ' + price : ''}`;
              }
            }, 1800);
            return;
          }
          if (btn) {
            btn.classList.remove('loading');
            btn.classList.add('added');
            if (textEl) textEl.textContent = '✓ Added to Cart';
          }
          openCart();
          setTimeout(() => {
            if (btn) {
              btn.classList.remove('added');
              btn.disabled = false;
              const activeVariant = document.querySelector('.variant-btn.active');
              const price = activeVariant ? activeVariant.dataset.price : '';
              if (textEl) textEl.textContent = `Add to Cart${price ? ' — ' + price : ''}`;
            }
          }, 1500);
        })
        .catch(err => {
          console.error('Product form error:', err);
          if (btn) { btn.classList.remove('loading'); btn.disabled = false; }
          if (textEl) textEl.textContent = 'Add to Cart';
        });
    });
  }

  // ── Init cart count on load ──────────────────────────────
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => { if (cartCount) cartCount.textContent = cart.item_count; })
    .catch(() => {});

});

// ══════════════════════════════════════
// JOURNALS SHOP — Filter + Quiz
// ══════════════════════════════════════

(function initShop() {

  // ── Filter tabs ──────────────────────────────────────────
  const filterBtns = document.querySelectorAll('.filter-btn');
  const shopCards  = document.querySelectorAll('.shop-card');
  const shopEmpty  = document.getElementById('shopEmpty');

  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const filter = btn.dataset.filter;
      let visibleCount = 0;

      shopCards.forEach(card => {
        const tags = card.dataset.tags || '';
        const show = filter === 'all' || tags.includes(filter);
        card.classList.toggle('hidden', !show);
        if (show) visibleCount++;
      });

      if (shopEmpty) shopEmpty.style.display = visibleCount === 0 ? 'block' : 'none';
    });
  });

  // ── Quiz logic ───────────────────────────────────────────
  const quizOpen    = document.getElementById('quizOpen');
  const quizOverlay = document.getElementById('quizOverlay');
  const quizModal   = document.getElementById('quizModal');
  const quizClose   = document.getElementById('quizClose');
  const quizRetake  = document.getElementById('quizRetake');
  const quizSteps   = document.querySelectorAll('.quiz-step');

  if (!quizOpen || !quizModal) return;

  let answers = [];
  let currentStep = 1;

  // Quiz results are editable in Theme Editor → Journals Shop section.
  // They are rendered into a JSON tag (#quizData); these are fallbacks only.
  let results = {
    design: {
      title: 'DESIGN',
      desc: 'You\'re ready to build. The DESIGN journal takes you through four phases — Unlearn, Uncover, Design, Become — to help you architect the life you actually want. This is your journal.',
      url: '/pages/design'
    },
    unsent: {
      title: 'UNSENT',
      desc: 'You\'re carrying something that needs to be put down. The UNSENT journal gives you the space to write the words you never said — then close the chapter and move forward lighter.',
      url: '/collections/all'
    },
    reckoning: {
      title: 'THE RECKONING',
      desc: 'You\'re done almost-starting. The Reckoning is a 12-month, chapter-by-chapter commitment system. This is the year you stop drifting and start executing.',
      url: '/collections/all'
    }
  };
  const quizDataEl = document.getElementById('quizData');
  if (quizDataEl) {
    try {
      const parsed = JSON.parse(quizDataEl.textContent);
      if (parsed && parsed.design && parsed.unsent && parsed.reckoning) results = parsed;
    } catch (e) { /* keep fallbacks */ }
  }

  function openQuiz() {
    quizModal.classList.add('open');
    quizModal.setAttribute('aria-hidden', 'false');
    quizOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    resetQuiz();
  }

  function closeQuiz() {
    quizModal.classList.remove('open');
    quizModal.setAttribute('aria-hidden', 'true');
    quizOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function resetQuiz() {
    answers = [];
    currentStep = 1;
    quizSteps.forEach(s => s.classList.remove('active'));
    const first = document.querySelector('.quiz-step[data-step="1"]');
    if (first) first.classList.add('active');
    document.querySelectorAll('.quiz-option').forEach(o => o.classList.remove('selected'));
  }

  function showStep(step) {
    quizSteps.forEach(s => s.classList.remove('active'));
    const next = document.querySelector(`.quiz-step[data-step="${step}"]`);
    if (next) next.classList.add('active');
  }

  function getResult() {
    // Simple scoring: map answer patterns to journals
    const all = answers.join(',');
    if (all.includes('carrying') || all.includes('emotional') || all.includes('relationship')) {
      return results.unsent;
    } else if (all.includes('drifting') || all.includes('longterm') || all.includes('year')) {
      return results.reckoning;
    } else {
      return results.design;
    }
  }

  function showResult() {
    const result = getResult();
    const titleEl = document.getElementById('quizResultTitle');
    const descEl  = document.getElementById('quizResultDesc');
    const btnEl   = document.getElementById('quizResultBtn');
    if (titleEl) titleEl.textContent = result.title;
    if (descEl)  descEl.textContent  = result.desc;
    if (btnEl)   { btnEl.textContent = `Get ${result.title}`; btnEl.href = result.url; }
    showStep('result');
  }

  // Bind option clicks
  document.querySelectorAll('.quiz-option').forEach(opt => {
    opt.addEventListener('click', () => {
      const step = opt.closest('.quiz-step');
      const stepNum = parseInt(step.dataset.step);
      answers[stepNum - 1] = opt.dataset.value;

      // Visual feedback
      step.querySelectorAll('.quiz-option').forEach(o => o.classList.remove('selected'));
      opt.classList.add('selected');

      // Advance
      setTimeout(() => {
        if (stepNum < 3) {
          showStep(stepNum + 1);
        } else {
          showResult();
        }
      }, 320);
    });
  });

  quizOpen.addEventListener('click', openQuiz);
  quizClose.addEventListener('click', closeQuiz);
  quizOverlay.addEventListener('click', closeQuiz);
  if (quizRetake) quizRetake.addEventListener('click', resetQuiz);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeQuiz(); });

})();
